// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Kv2M","left":"StickyBox_left__2Lj13","right":"StickyBox_right__3cqkL"};